import { render } from "./MainCard.vue?vue&type=template&id=505e5247&scoped=true"
import script from "./MainCard.vue?vue&type=script&lang=js"
export * from "./MainCard.vue?vue&type=script&lang=js"

import "./MainCard.vue?vue&type=style&index=0&id=505e5247&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-505e5247"]])

export default __exports__